/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import {
  Box,
  Col,
  FlexContainer,
  Loader,
  Row,
  Spacer,
  Text,
  theme,
} from "@nordcloud/gnui";
import { useEstateDownloadQuery } from "~/generated/graphql";
import { BreadcrumbsBox } from "~/components";
import { ERROR_TEXT, SUCCESS_TEXT } from "~/constants";
import { useQueryState } from "~/hooks";
import { showError, showSuccess } from "~/services/toast";

import ninjaStand from "../../assets/images/ninjaStanding.png";

type RouteParams = {
  exportJobId: string;
};

const StyledImage = styled.img`
  width: 5rem;
  height: auto;
  margin-bottom: ${theme.spacing.spacing07};
`;

export function ExportPage() {
  const { exportJobId } = useParams<RouteParams>();
  const {
    state: { viewUrl },
  } = useQueryState<{ viewUrl: string }>();

  const { data, loading } = useEstateDownloadQuery({
    variables: { exportJobId },
  });

  React.useEffect(() => {
    if (typeof window !== "undefined" && data) {
      try {
        window.location.href = data?.downloadExport?.fileUrl || "";
        showSuccess(SUCCESS_TEXT.download);
      } catch {
        showError(ERROR_TEXT.default);
      }
    }
  }, [data]);

  const breadcrumbs = [
    { label: "Home", uri: "/" },
    { label: "Download", uri: "/" },
  ];

  return (
    <Row>
      <Col>
        <BreadcrumbsBox title="Download" customBreadcrumbs={breadcrumbs} />
        <Box spacing="spacing04">
          <Row>
            <Col offset={1} sm={4}>
              <Box boxStyle="lightGrey">
                <FlexContainer direction="column" justifyContent="center">
                  <StyledImage alt="ninjaStand" src={ninjaStand} />
                  <Spacer />
                  <Text size="lg" weight="medium">
                    Download IBM Multicloud Accelerator csv report
                  </Text>
                  {loading ? (
                    <Loader />
                  ) : (
                    <>
                      <Text align="center">
                        Your report should start downloading in a few seconds.
                        If not, please{" "}
                        <a download href={data?.downloadExport?.fileUrl}>
                          click here
                        </a>{" "}
                        to download.
                      </Text>
                      <Text align="center">
                        If you would like to see the page related to the csv
                        report, please <a href={viewUrl}>click here.</a>
                      </Text>
                    </>
                  )}
                </FlexContainer>
              </Box>
            </Col>
          </Row>
        </Box>
      </Col>
    </Row>
  );
}
